import React from 'react';
import SecondaryTitle from "../../Components/SecondaryTitle";
import Text from "../../Components/Text";
import {OPENING, TRANSFERRING} from "../../constants";

const IsaDetails = (props) => {
    const {
        data = {
            'first_isa_option_selected':    '',
            'second_isa_option_selected':   false,
            'opening_isa_detail':           {
                'isa_type':     '',
                'isa_amount':   '',
            },
            'transferring_isa_detail':      {
                'isa_type':                                      '',
                'isa_amount':                                    '',
                'current_isa_reference_number':                  '',
                'current_isa_manager':                           '',
                'current_isa_manager_address':                   '',
                'current_isa_transfer_date_requested':           '',
                'current_isa_first_subscription_current_year':   '',
            }
        },
    } = props;

    if (data.opening_isa_detail !== null && data.transferring_isa_detail !== null) {
        data.second_isa_option_selected = true;
    }

    const renderOpeningDetails = () => (
        <>
            {(data.first_isa_option_selected === 'Transferring' && data.second_isa_option_selected) && (
                <>
                    <div className={'col-sm-6 ps-0'}>
                        <Text style={{fontWeight: 'bold'}}>Do you want to open a new Cash ISA too?</Text>
                    </div>
                    <div className={'col-sm-6 ps-0'}>
                        <Text>Yes</Text>
                    </div>
                </>
            )}
            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Type of ISA:</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text>{data.opening_isa_detail.isa_type}</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Amount:</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text>{data.opening_isa_detail.isa_amount}</Text>
            </div>
        </>
    );

    const renderTransferringDetails = () => (
        <>
            {(data.first_isa_option_selected === OPENING && data.second_isa_option_selected) && (
                <>
                    <div className={'col-sm-6 ps-0'}>
                        <Text style={{fontWeight: 'bold'}}>Do you want to transfer a Cash ISA too?</Text>
                    </div>
                    <div className={'col-sm-6 ps-0'}>
                        <Text>Yes</Text>
                    </div>
                </>
            )}
            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Type of ISA:</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.isa_type}</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Amount:</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.isa_amount}</Text>
            </div>
            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>ISA reference number:</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.current_isa_reference_number}</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Current ISA manager:</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.current_isa_manager}</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Current ISA manager's address:</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.current_isa_manager_address}</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Date transfer request:</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.current_isa_transfer_date_requested}</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text className={'fw-bold'}>Date of first subscription in current year:</Text>
            </div>

            <div className={'col-sm-6 ps-0'}>
                <Text>{data.transferring_isa_detail.current_isa_first_subscription_current_year}</Text>
            </div>
        </>
    );

    return (
        <React.Fragment>
            <SecondaryTitle>ISA Information</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-sm-6 ps-0'}>
                    <Text style={{fontWeight: 'bold'}}>Are you opening or transferring cash ISA:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.first_isa_option_selected}</Text>
                </div>

                {data.first_isa_option_selected === OPENING && renderOpeningDetails()}
                {data.first_isa_option_selected === TRANSFERRING && renderTransferringDetails()}

                {data.second_isa_option_selected && data.first_isa_option_selected !== OPENING && renderOpeningDetails()}
                {data.second_isa_option_selected && data.first_isa_option_selected !== TRANSFERRING && renderTransferringDetails()}
            </div>
        </React.Fragment>
    );
}

export default IsaDetails;
